module.exports = __webpack_public_path__ + "static/media/guide_desktop_03.cda4009e.svg";